import './styles.css';

const Container = ({ children, className = '' }) => {
	return (
		<div className={`container-component__olib ${className}`}>{children}</div>
	);
};

export default Container;
